/* eslint-disable default-case */
import { between, isHoliday } from "@holiday-jp/holiday_jp";

/**
 * 日付関連
 */

import {
  suppressZero,
  paddingZero,
} from "./string";

/** yyyMMddhhmmをdate型に変換 */
export const chgStringToDate = (str) => {
  const year = parseInt(str.substring(0, 4));
  const month = parseInt(str.substring(4, 6));
  const day = parseInt(str.substring(6, 8));
  const hour = parseInt(str.substring(8, 10));
  const min = parseInt(str.substring(10, 12));
  const date = new Date(year, month - 1, day, hour, min);

  return date;
}

/** 現在年月日 取得(yyyyMMdd) */
export const chgDateToString = (date, str) => {
  var res = "" + date.getFullYear() + str
    + paddingZero(date.getMonth() + 1) + str
    + paddingZero(date.getDate());
  return res;
}

/**
 * 年月日 整形
 * @param {*} str yyyyMMdd
 * @returns yyyy年MM月dd日(MMとddは0抜き)
 */
export const formatYmd = (str) => {
  return str.slice(0, 4) + "年"
    + suppressZero(str.slice(4, 6) + "月"
      + suppressZero(str.slice(6, 8)) + "日");
}

/**
 * 時刻 整形
 * @param {*} str hhmm
 * @returns hh:mm(hh0抜き)
 */
export const formatJkk = (str) => {
  return suppressZero(str.slice(0, 2)) + ":" + str.slice(2, 4);
}

/**
 * 日付（yyyyMMdd）をDate型に変換
 * @param {yyyyMMdd} str 日付
 */
export const changeStringToDate = (str) => {
  return new Date(str.slice(0, 4), str.slice(4, 6) - 1, str.slice(6, 8));
}

/**
 * 曜日名称 取得
 * @param {*} str yyyyMMdd
 * @returns 曜日名称
 */
export const getWeekDayNm = (str) => {
  switch (String(changeStringToDate(str).getDay())) {
    case '0':
      return '日'
    case '1':
      return '月'
    case '2':
      return '火'
    case '3':
      return '水'
    case '4':
      return '木'
    case '5':
      return '金'
    case '6':
      return '土'
  }
}

/**
 * 引数で渡された期間に存在する祝日をリストで返却
 * @param {Date} date1 開始日
 * @param {Date} date2 終了日
 * @returns 祝日リスト
 */
export const getHolidays = (date1, date2) => {
  return between(date1, date2);
}

/**
 * 日付を比較し、一致しているかをチェック
 * @param {Date} date1 比較対象Date1
 * @param {Date} date2 比較対象Date2
 * @returns 一致しているか
 */
export const isDateMatch = (date1, date2) => {
  let result = false;
  if (date1.getFullYear() === date2.getFullYear()
      && date1.getMonth() === date2.getMonth()
      && date1.getDate() === date2.getDate()) {
    result = true;
  }
  return result;
}

/**
 * 翌営業日を取得（日曜日・祝日は定休日）
 * @param {date} date 起点日
 * @returns 翌営業日
 */
export const getNextBusinessDay = (date) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + 1); // 翌日以降の営業日を取得したいため、1日進める
  let nextBusinessDay = new Date(nextDate);

  // 日曜日または祝日の場合、営業日まで進める
  while (nextBusinessDay.getDay() === 0 || isHoliday(nextBusinessDay)) {
    nextBusinessDay.setDate(nextBusinessDay.getDate() + 1);
  }

  return nextBusinessDay;
}

/**
 * 現在日時時刻・カレンダー表示日から活性非活性状態を判定
 * @param {Date} date カレンダー表示日
 * @param {String} jkt 時間帯「01:09:00〜」「02:13:00〜」「03:15:00〜」
 * @param {Boolean} holiday 「false：通常日」「true:祝日」
 * @returns true :非活性
 *          false:活性
 */
export const isDisabledCalendarCell = (date, jkt) => {

  const nowDate = new Date();

  // 当日（現在日とカレンダーの表示日が同日）の場合
  if(isDateMatch(nowDate, changeStringToDate(date))) {
    // 12時以降の閲覧は全て非活性
    if (12 <= nowDate.getHours()) return true;

    // 時間枠「01:09:00〜」の場合、現在時刻が9時以降非活性
    if (jkt === "01" ) return true;
  }

  // 現在日の翌日とカレンダー表示日が同日の場合
  const nextDate = new Date();
  nextDate.setDate(nextDate.getDate() + 1);
  if(isDateMatch(nextDate, changeStringToDate(date))) {
    // 翌日の時間帯「01:09:00〜」の場合、現在時刻が19時以降非活性
    if (jkt === "01" && 19 <= nowDate.getHours()) return true;
  }

  return false;
}
